"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spilimbergo": {
    "2ae81e82": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "skipSearch": false
    }],
    "baseglia": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b81eabb": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "skipSearch": false
    }],
    "brindisi": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3893534": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "skipSearch": false
    }],
    "casasola": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1519d7d": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "skipSearch": false
    }],
    "gaio": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cfb64eb9": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "skipSearch": false
    }],
    "la-favorita": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9915db23": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "skipSearch": false
    }],
    "navarons": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3cb56ad": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "skipSearch": false
    }],
    "tauriano": [{
      "hkey": "d726682c",
      "slug": "spilimbergo",
      "name": "Spilimbergo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;